/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProcessEventCalendarEventDto } from '../models';
/**
 * RestProcessesEventCalendarApi - axios parameter creator
 */
export const RestProcessesEventCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessEventCalendarItem: async (processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createProcessEventCalendarItem', 'processId', processId)
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('createProcessEventCalendarItem', 'processEventId', processEventId)
            // verify required parameter 'processEventCalendarEventDto' is not null or undefined
            assertParamExists('createProcessEventCalendarItem', 'processEventCalendarEventDto', processEventCalendarEventDto)
            const localVarPath = `/api/processes/{processId}/events/{processEventId}/calendar-item`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processEventCalendarEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEventCalendarItem: async (processId: string, processEventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessEventCalendarItem', 'processId', processId)
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('getProcessEventCalendarItem', 'processEventId', processEventId)
            const localVarPath = `/api/processes/{processId}/events/{processEventId}/calendar-item`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessEventCalendarItem: async (processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessEventCalendarItem', 'processId', processId)
            // verify required parameter 'processEventId' is not null or undefined
            assertParamExists('updateProcessEventCalendarItem', 'processEventId', processEventId)
            // verify required parameter 'processEventCalendarEventDto' is not null or undefined
            assertParamExists('updateProcessEventCalendarItem', 'processEventCalendarEventDto', processEventCalendarEventDto)
            const localVarPath = `/api/processes/{processId}/events/{processEventId}/calendar-item`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processEventId}', encodeURIComponent(String(processEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processEventCalendarEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessesEventCalendarApi - functional programming interface
 */
export const RestProcessesEventCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessesEventCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventCalendarApi.createProcessEventCalendarItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessEventCalendarItem(processId: string, processEventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessEventCalendarEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessEventCalendarItem(processId, processEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventCalendarApi.getProcessEventCalendarItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesEventCalendarApi.updateProcessEventCalendarItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessesEventCalendarApi - factory interface
 */
export const RestProcessesEventCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessesEventCalendarApiFp(configuration)
    return {
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessEventCalendarItem(processId: string, processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventCalendarEventDto> {
            return localVarFp.getProcessEventCalendarItem(processId, processEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} processEventId 
         * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessesEventCalendarApi - interface
 */
export interface RestProcessesEventCalendarApiInterface {
    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessEventCalendarItem(processId: string, processEventId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessEventCalendarEventDto>;

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessesEventCalendarApi - object-oriented interface
 */
export class RestProcessesEventCalendarApi extends BaseAPI implements RestProcessesEventCalendarApiInterface {
    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig) {
        return RestProcessesEventCalendarApiFp(this.configuration).createProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessEventCalendarItem(processId: string, processEventId: number, options?: RawAxiosRequestConfig) {
        return RestProcessesEventCalendarApiFp(this.configuration).getProcessEventCalendarItem(processId, processEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {number} processEventId 
     * @param {ProcessEventCalendarEventDto} processEventCalendarEventDto Process event calendar event update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessEventCalendarItem(processId: string, processEventId: number, processEventCalendarEventDto: ProcessEventCalendarEventDto, options?: RawAxiosRequestConfig) {
        return RestProcessesEventCalendarApiFp(this.configuration).updateProcessEventCalendarItem(processId, processEventId, processEventCalendarEventDto, options).then((request) => request(this.axios, this.basePath));
    }
}

